import { useEffect, useState } from "react";
import HorizontalRow from "../../components/HorizontalRow";
import {
  fetchTrendingTV,
  fetchPopularTV,
  fetchTopRatedTV,
} from "../../api/tmdb";
import Header from "../../components/Header";

/* 🔑 Adapter: TV → Movie shape */
const adaptTVData = (data) =>
  Array.isArray(data)
    ? data.map((tv) => ({
        ...tv,
        title: tv.name,
        language: tv.original_language, // TMDB language code
        genre_ids: tv.genre_ids || [],
      }))
    : [];

/* 🎭 Genre → Mood mapping (BASED ON YOUR REQUIREMENT) */
const getMoodFromGenres = (genreIds = []) => {
  if (genreIds.includes(28)) return "action";        // 🔥 Action
  if (genreIds.includes(35)) return "feelgood";     // 😂 Comedy
  if (genreIds.includes(18)) return "emotional";    // 🎭 Drama
  if (genreIds.includes(10749)) return "romantic";  // ❤️ Romance
  if (genreIds.includes(27)) return "scary";        // 😱 Horror
  if (genreIds.includes(878)) return "scifi";       // 🚀 Sci‑Fi
  if (genreIds.includes(53) || genreIds.includes(9648))
    return "thriller";                              // 🧠 Thriller / Mystery

  return "all";
};

/* 🌐 Language filters */
const LANGUAGE_FILTERS = [
  { label: "All", value: "all" },
  { label: "Telugu", value: "te" },
  { label: "Tamil", value: "ta" },
  { label: "Hindi", value: "hi" },
  { label: "Malayalam", value: "ml" },
  { label: "Kannada", value: "kn" },
  { label: "English", value: "en" },
];

/* 🎭 Mood filters (WITH EMOJIS) */
const MOOD_FILTERS = [
  { label: "🔥 Action Packed", value: "action" },
  { label: "😂 Feel‑Good Fun", value: "feelgood" },
  { label: "🎭 Emotional Drama", value: "emotional" },
  { label: "❤️ Romantic Vibes", value: "romantic" },
  { label: "😱 Scary Nights", value: "scary" },
  { label: "🚀 Sci‑Fi Worlds", value: "scifi" },
  { label: "🧠 Mind‑Bending Thrillers", value: "thriller" },
];

function WebSeries() {
  const [trending, setTrending] = useState([]);
  const [popular, setPopular] = useState([]);
  const [topRated, setTopRated] = useState([]);

  const [selectedLanguage, setSelectedLanguage] = useState("all");
  const [selectedMood, setSelectedMood] = useState("all");

  const [searchQuery, setSearchQuery] = useState("");
  const [profileOpen, setProfileOpen] = useState(false);

  /* ✅ Universal filter function */
  const applyFilters = (list) =>
    list.filter((item) => {
      const itemMood = getMoodFromGenres(item.genre_ids);

      // Language filter
      if (
        selectedLanguage !== "all" &&
        item.language !== selectedLanguage
      ) {
        return false;
      }

      // Mood filter
      if (
        selectedMood !== "all" &&
        itemMood !== selectedMood
      ) {
        return false;
      }

      // Search filter
      if (
        searchQuery &&
        !item.title?.toLowerCase().includes(searchQuery.toLowerCase())
      ) {
        return false;
      }

      return true;
    });

    const clearFilters = () => {
        setSelectedLanguage("all");
        setSelectedMood("all");
        setSearchQuery("");
      };

  useEffect(() => {
    fetchTrendingTV().then((data) =>
      setTrending(adaptTVData(data))
    );
    fetchPopularTV().then((data) =>
      setPopular(adaptTVData(data))
    );
    fetchTopRatedTV().then((data) =>
      setTopRated(adaptTVData(data))
    );
  }, []);

  return (
    <div>
      <Header
        searchQuery={searchQuery}
        setSearchQuery={setSearchQuery}
        onProfile={() => setProfileOpen(true)}
      />

      {/* 🌐 Language Filter + Clear */}
<div className="filter-bar">
  <div className="filter-chips">
    {LANGUAGE_FILTERS.map((l) => (
      <button
        key={l.value}
        className={`filter-chip ${
          selectedLanguage === l.value ? "active" : ""
        }`}
        onClick={() => setSelectedLanguage(l.value)}
      >
        {l.label}
      </button>
    ))}
  </div>

  {(selectedLanguage !== "all" ||
    selectedMood !== "all" ||
    searchQuery.trim() !== "") && (
    <button
      className="clear-filters-btn"
      onClick={clearFilters}
    >
      Clear ✕
    </button>
  )}
</div>

{/* 🎭 Mood Filters (Horizontal Scroll like Home) */}
<div className="filter-bar scroll-x">
  {MOOD_FILTERS.map((m) => (
    <button
      key={m.value}
      className={`filter-chip ${
        selectedMood === m.value ? "active" : ""
      }`}
      onClick={() => setSelectedMood(m.value)}
    >
      {m.label}
    </button>
  ))}
</div>


      

      <HorizontalRow
        title="Trending Web Series"
        movies={applyFilters(trending)}
      />

      <HorizontalRow
        title="Popular Web Series"
        movies={applyFilters(popular)}
      />

      <HorizontalRow
        title="Top Rated Web Series"
        movies={applyFilters(topRated)}
      />
    </div>
  );
}

export default WebSeries;
